import React, { memo } from "react";
import { IconButton, List, ListItemIcon, ListItemButton, FormControlLabel, Divider, Switch, ListItem, ListItemText, useTheme, Tooltip, Typography, Badge, Box, Container} from "@mui/material";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { DrawerHeader, Drawer, LOCATION_ROOT, LOCATION_ADMIN, LOCATION_TUTOR, BootstrapTooltip } from "../Helper/SidebarHelper";
import { useDispatch, useSelector } from "react-redux";
import {setLocation} from "../Reducers/navigation";


const SideBar = ({navState, openNav}) => {

    const theme = useTheme();
    const dispatch = useDispatch();
    const permissions = useSelector((state) => state.role);
    const location = useSelector((state) => state.navigation.location);

    // Custom hook giving email
    /**
     * 
     * @param {Number} location
     *  Changes the location tof the current page based.
     *  Change the state of redux user.location  
     */
    const changeLocation = (key) => {
        dispatch(setLocation(key));
        openNav(false);
    }


    return (
        <>
        <Drawer color="primary" variant="permanent" open={navState}>
        <DrawerHeader>
          <IconButton onClick={() => openNav(false)}>
            {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
          </IconButton>
        </DrawerHeader>
          <Divider />

          <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <List sx={{ flexGrow: 1 }}>
              {permissions.role === "ROOT" &&
                Object.entries(LOCATION_ROOT).map(([key, value]) => (
                  <ListItem disablePadding sx={{ display: 'block' }} key={key}>
                    <BootstrapTooltip title={key} placement="right">
                      <ListItemButton
                        selected={key === location}
                        color="primary"
                        sx={{
                          minHeight: 48,
                          justifyContent: navState ? 'initial' : 'center',
                          px: 2.5,
                        }}
                        onClick={() => changeLocation(key)}
                      >
                        <ListItemIcon
                          color="primary"
                          sx={{
                            minWidth: 0,
                            mr: navState ? 3 : 'auto',
                            justifyContent: 'center',
                          }}
                        >
                          {value.icon}
                        </ListItemIcon>
                        <ListItemText primary={key} sx={{ opacity: navState ? 1 : 0, fontWeight: 'bold' }} />
                      </ListItemButton>
                    </BootstrapTooltip>
                  </ListItem>
                ))
              }

              { permissions.role === "ADMIN" &&
                Object.entries(LOCATION_ADMIN).map(([key, value]) => (
                  <ListItem disablePadding sx={{ display: 'block' }} key={key}>
                    <BootstrapTooltip title={key} placement="right">
                      <ListItemButton
                        color="primary"
                        selected={key === location}
                        sx={{
                          minHeight: 48,
                          justifyContent: navState ? 'initial' : 'center',
                          px: 2.5,
                        }}
                        onClick={() => changeLocation(key)}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: navState ? 3 : 'auto',
                            justifyContent: 'center',
                          }}
                        >
                          {value.icon}
                        </ListItemIcon>
                        <ListItemText primary={key} sx={{ opacity: navState ? 1 : 0, fontWeight: 'bold' }} />
                      </ListItemButton>
                    </BootstrapTooltip>
                  </ListItem>
                ))
              }

              {permissions.role === "TUTOR" &&
                Object.entries(LOCATION_TUTOR).map(([key, value]) => (
                  <ListItem disablePadding sx={{ display: 'block' }} key={key}>
                    <BootstrapTooltip title={key} placement="right">
                      <ListItemButton
                        color="primary"
                        selected={key === location}
                        sx={{
                          minHeight: 48,
                          justifyContent: navState ? 'initial' : 'center',
                          px: 2.5,
                        }}
                        onClick={() => changeLocation(key)}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: navState ? 3 : 'auto',
                            justifyContent: 'center',
                          }}
                        >
                          {value.icon}
                        </ListItemIcon>
                        <ListItemText primary={key} sx={{ opacity: navState ? 1 : 0, fontWeight: 'bold' }} />
                      </ListItemButton>
                    </BootstrapTooltip>
                  </ListItem>
                ))
              }
            </List>
          </Box>
        </Drawer>
      </>
    )
}

export default memo(SideBar);